import React from "react";
import { FlaskConical, ScanSearch, HeartHandshake, Leaf, Gem, Atom, Hexagon, Diamond, ClipboardCheck, Sparkles, ShieldCheck, Scale } from "lucide-react";

export const COMPARE_ICONS: Record<string, any> = { flask: FlaskConical, search: ScanSearch, handshake: HeartHandshake, leaf: Leaf, gem: Gem, atom: Atom,
  hexagon: Hexagon, diamond: Diamond, clipboard: ClipboardCheck, sparkles: Sparkles, shield: ShieldCheck, scale: Scale };

const parse = (t: string) => (t || "").split("\n").map((l) => l.split("|").map((x) => x.trim())).filter((p) => p.some(Boolean))
  .map(([icon, title, text]) => ({ icon, title, text }));

function Col({ heading, rows, side }: any) {
  return (
    <div className={`py-10 px-6 md:px-10 ${side === "l" ? "bg-[#F4F4F3]" : "bg-[#EDEDEB]"}`}>
      <h3 className="font-display uppercase tracking-[0.08em] text-xl md:text-2xl text-center">{heading}</h3>
      <ul className="mt-10 space-y-10">
        {rows.map((r: any, i: number) => {
          const I = COMPARE_ICONS[r.icon] || Diamond;
          return (
            <li key={i} className="text-center" data-testid={`compare-${side}-${i}`}>
              <I size={30} strokeWidth={1} className="mx-auto" />
              <p className="mt-3 text-sm font-medium">{r.title}</p>
              {r.text && <p className="mt-1 text-[13px] text-neutral-600 max-w-[260px] mx-auto leading-relaxed">{r.text}</p>}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export function Compare({ b }: any) {
  return (
    <section className="max-w-[1000px] mx-auto px-5 md:px-12 pb-16 md:pb-24 grid md:grid-cols-2 gap-1" data-testid="compare-block">
      <Col heading={b.left_heading} rows={parse(b.left)} side="l" />
      <Col heading={b.right_heading} rows={parse(b.right)} side="r" />
    </section>
  );
}
